'use strict';

var tealium = require('../tealium');
	

var confirmation = {
    init: function (){
    	var obj={};
    	if(utag_data.payment_type) {
    		obj.event_name = utag_data.payment_type;
    	}
    	if(utag_data.order_payment_type) {
    		obj.order_payment_type = utag_data.order_payment_type;
    	}
    	if(utag_data.order_payment_method_type) {
    		obj.order_payment_method_type = utag_data.order_payment_method_type;
    	}
    	if(utag_data.order_payment_amount) {
    		obj.order_payment_amount = utag_data.order_payment_amount;
    	}
    	if(utag_data.order_subtotal) {
    		obj.order_subtotal = utag_data.order_subtotal;
    	}
    	if(utag_data.order_shipping) {
    		obj.order_shipping = utag_data.order_shipping;
    	}
    	if(utag_data.order_tax) {
    		obj.order_tax = utag_data.order_tax;
    	}
    	if(utag_data.order_total) {
    		obj.order_total = utag_data.order_total;
    	}
		if(utag_data.order_payment_id){
			obj.order_payment_id = order_payment_id;
		}
    	tealium.triggerEvent(obj);
    	
    }
};
exports.init = confirmation.init;
